"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventType;
(function (EventType) {
    EventType["globalSearchChange"] = "ksys-global-search-change";
    EventType["globalInputsChange"] = "ksys-global-inputs-change";
    EventType["appInitialized"] = "ksys-app-initialized";
    EventType["paginationChange"] = "ksys-on-pagination-change";
    EventType["updatePagination"] = "ksys-update-pagination";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=EventType.js.map